import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useAuctionCarsCarSold() {
  const { startListen } = useWebSocketStore()
  const { updateAuctionCar } = useUpdateCar()

  const carSold = () => {
    startListen({
      eventName: 'premium.CAR_SOLD',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId } = event.context

        updateAuctionCar('unknown', carId, (data) => {
          return {
            ...data,
            state: 'SOLD',
          }
        })
      },
    })
  }

  return { carSold }
}
